import { FIRST_NAME_TEXT, LAST_NAME_TEXT, TITLE_TEXT } from '../../../../../constants/common-labels.constants';
import { FormVmItemConfigType, InitialDataFromConfig } from '../../../../../infrastructure/form-viewmodel-controller';
import { buildConfigList } from '../../../../../infrastructure/utils/form-config.utils';
import { trimSpacesLeft } from '../../../../../modules/formatters';
import { plainText, url } from '../../../../../modules/validators';
import { ACTIVE_STATUS_TEXT, LINKEDIN_URL_TEXT, MIDDLE_NAME_TEXT, NAME_NOTES_TEXT, NAME_PHONETIC_TEXT, NAME_PREFIX_TEXT, NAME_SUFFIX_TEXT, PHONE_DIRECT_TEXT, PHONE_MOBILE_TEXT, PREFERRED_NAME_TEXT, VIP_FLAG_TEXT } from './rolodex-contact-text';

export type RolodexContactInitialData = InitialDataFromConfig<typeof ROLODEX_CONTACT_FORM_CONFIG>;

export enum RolodexContactFieldKey {
    FIRST_NAME = 'firstName',
    LAST_NAME = 'lastName',
    PREFERRED_NAME = 'preferredName',
    NAME_PREFIX = 'namePrefix',
    MIDDLE_NAME = 'middleName',
    NAME_SUFFIX = 'nameSuffix',
    NAME_NOTES = 'nameNotes',
    NAME_PHONETIC = 'namePhonetic',
    TITLE = 'title',
    PHONE_DIRECT = 'phoneDirect',
    PHONE_MOBILE = 'phoneMobile',
    LINKEDIN_URL = 'linkedinUrl',
    ACTIVE_STATUS = 'activeStatus',
    VIP_FLAG = 'vipFlag',
}

export const ROLODEX_CONTACT_FORM_CONFIG = {
    [RolodexContactFieldKey.FIRST_NAME]: {
        labelDescriptor: FIRST_NAME_TEXT,
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.LAST_NAME]: {
        labelDescriptor: LAST_NAME_TEXT,
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.PREFERRED_NAME]: {
        labelDescriptor: PREFERRED_NAME_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.MIDDLE_NAME]: {
        labelDescriptor: MIDDLE_NAME_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.NAME_PREFIX]: {
        labelDescriptor: NAME_PREFIX_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.NAME_SUFFIX]: {
        labelDescriptor: NAME_SUFFIX_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.NAME_NOTES]: {
        labelDescriptor: NAME_NOTES_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.NAME_PHONETIC]: {
        labelDescriptor: NAME_PHONETIC_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.TITLE]: {
        labelDescriptor: TITLE_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.PHONE_DIRECT]: {
        labelDescriptor: PHONE_DIRECT_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.PHONE_MOBILE]: {
        labelDescriptor: PHONE_MOBILE_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.LINKEDIN_URL]: {
        labelDescriptor: LINKEDIN_URL_TEXT,
        defaultValue: '',
        validators: [plainText.maxLength.short, url.regExp],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.ACTIVE_STATUS]: {
        labelDescriptor: ACTIVE_STATUS_TEXT,
        defaultValue: '',
        validators: [plainText.required, plainText.maxLength.short],
        formatters: [trimSpacesLeft]

    },
    [RolodexContactFieldKey.VIP_FLAG]: {
        labelDescriptor: VIP_FLAG_TEXT,
        defaultValue: false,
    },
};

export const rolodexContactConfigList: FormVmItemConfigType[] = buildConfigList(ROLODEX_CONTACT_FORM_CONFIG);
